import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up crm-form-wrapper crm-form-new" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "qc-item-wrap crm-item-wrap crm-item-wrap-bare" }
const _hoisted_5 = {
  key: 0,
  class: "quick-add-heading"
}
const _hoisted_6 = {
  key: 1,
  class: "customer-request-tags"
}
const _hoisted_7 = {
  key: 2,
  class: "board-item-btns"
}
const _hoisted_8 = {
  key: 0,
  class: "board-item-tags"
}
const _hoisted_9 = { class: "board-item-tags-tags" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { class: "board-tip-tap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_tip_tap = _resolveComponent("tip-tap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          (_ctx.heading)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(_ctx.heading), 1))
            : _createCommentVNode("", true),
          _cache[7] || (_cache[7] = _createElementVNode("div", {
            class: "crm-item-label",
            style: {"margin-top":"0"}
          }, "Name", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            style: {"margin":"0 0 15px"},
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.Name) = $event)),
            ref: "nameInput",
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.submit()), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.formData.Name]
          ]),
          (_ctx.displayTags.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayTags, (tag, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    style: _normalizeStyle('background:'+tag.color)
                  }, _toDisplayString(tag.name), 5))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.allTags.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    onClick: _cache[3] || (_cache[3] = () => { _ctx.showTags = !_ctx.showTags; })
                  }, "Tags"),
                  (_ctx.showTags)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: "board-item-tags-close",
                          onClick: _cache[4] || (_cache[4] = () => { _ctx.showTags = false })
                        }, [
                          _createVNode(_component_svg_icon, { icon: "x" })
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTags, (tag, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "checkbox-input customer-request-tag",
                              style: _normalizeStyle('background:'+tag.color)
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                style: {"margin-left":"10px"},
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((tag.checked) = $event)
                              }, null, 8, _hoisted_10), [
                                [_vModelCheckbox, tag.checked]
                              ]),
                              _createElementVNode("span", null, _toDisplayString(tag.name), 1)
                            ], 4))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "crm-item-label" }, "Description", -1)),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_tip_tap, {
              modelValue: _ctx.formData.Description,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.Description) = $event)),
              "hide-h3": true,
              "hide-h4": true,
              "hide-table": true
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("input", {
            style: {"margin-top":"20px"},
            class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
            type: "submit",
            value: "Submit",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submit()))
          }, null, 2)
        ])
      ])
    ])
  ]))
}